/* Barberworld Search Overlay v6 — 100% dinámico + precios COP correctos */
(function(){
'use strict';

const RK='bw_r', MAX=6;
const POPULAR=['ceras','cortadora','afeitadora','clipper','plancha','barberia','wahl','jrl'];

const ALL_COLS = window.BW_COLS || [];
const FEATURED  = window.BW_FEATURED || [];

/* PRECIO: ambos (Liquid inyectado y suggest.json) llegan en UNIDADES COP.
   Liquid: ya dividido /100 en el snippet. suggest.json: viene en unidades (ej 239990.00).
   Por eso NO se divide aquí. */
function money(n){
  const v=Math.round(parseFloat(n)||0);
  return '$'+v.toLocaleString('es-CO',{minimumFractionDigits:0,maximumFractionDigits:0});
}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function recents(){try{return JSON.parse(localStorage.getItem(RK)||'[]');}catch{return[];}}
function saveR(t){if(!t||t.length<2)return;let r=recents().filter(x=>x.toLowerCase()!==t.toLowerCase());r.unshift(t);try{localStorage.setItem(RK,JSON.stringify(r.slice(0,MAX)));}catch{}}
function clearR(){try{localStorage.removeItem(RK);}catch{}}

function getAC(q,suggestions){
  if(!q)return'';
  const ql=q.toLowerCase();
  const m=suggestions.find(s=>s.text.toLowerCase().startsWith(ql));
  return m?m.text.slice(q.length):'';
}

function highlight(text,q){
  if(!q)return esc(text);
  const i=text.toLowerCase().indexOf(q.toLowerCase());
  if(i<0)return esc(text);
  return esc(text.slice(0,i))+'<strong>'+esc(text.slice(i,i+q.length))+'</strong>'+esc(text.slice(i+q.length));
}

function card(img,handle,vendor,title,price,cmp,badge){
  const bdg=badge==='sale'?'<span class="bw-card__badge bw-card__badge--sale">Oferta</span>'
    :badge==='sold'?'<span class="bw-card__badge bw-card__badge--soldout">Agotado</span>':'';
  const cmpHtml=(cmp&&cmp>price)?`<span class="bw-card__compare">${money(cmp)}</span>`:'';
  return`<a href="/products/${handle}" class="bw-card">
    <div class="bw-card__img">${img?`<img src="${esc(img)}" alt="${esc(title)}" loading="lazy">`:'<div style="width:100%;height:100%;background:#f0f5ff"></div>'}${bdg}</div>
    <div class="bw-card__info"><div class="bw-card__vendor">${esc(vendor||'')}</div>
    <p class="bw-card__title">${esc(title)}</p>
    <div class="bw-card__prices"><span class="bw-card__price">${money(price)}</span>${cmpHtml}</div>
    </div></a>`;
}

function colsPanel(){
  if(!ALL_COLS.length)return'';
  let h='<div class="bw-cats-panel"><div class="bw-cats-header"><strong>\u00bfNecesitas ayuda?</strong>&nbsp;<span>Filtra por <strong>Categor\u00eda</strong></span></div><div class="bw-cats-track">';
  ALL_COLS.forEach(c=>{h+=`<a href="/collections/${c.h}" class="bw-cat-chip">${esc(c.t)}</a>`;});
  return h+'</div></div>';
}

function emptyHTML(){
  const r=recents();
  let h=colsPanel()+'<div class="bw-empty">';
  if(r.length){
    h+=`<div class="bw-sec-title">B\u00fasquedas recientes<button type="button" id="bw-clr-r">Borrar</button></div><ul class="bw-recents">`;
    r.forEach(t=>{h+=`<li><a href="#" data-q="${esc(t)}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>${esc(t)}</a></li>`;});
    h+='</ul>';
  }
  h+='<div class="bw-sec-title">B\u00fasquedas populares</div><div class="bw-chips">';
  POPULAR.forEach(t=>{h+=`<a class="bw-chip" href="#" data-q="${esc(t)}">${esc(t)}</a>`;});
  h+='</div>';
  if(FEATURED.length){
    h+='<div class="bw-sec-title" style="margin-top:8px">Productos recomendados</div><div class="bw-grid">';
    FEATURED.forEach(p=>{
      const sale=(p.cmp&&p.cmp>p.p);
      h+=card(p.img,p.h,p.v,p.t,p.p,p.cmp,sale?'sale':(p.avail===false?'sold':null));
    });
    h+='</div>';
  }
  return h+'</div>';
}

function resultsHTML(data,q){
  const {queries,collections,products}=data;
  const hasL=queries.length>0||collections.length>0;
  if(!hasL&&!products.length)
    return`<div class="bw-noresults"><h3>Sin resultados para &ldquo;${esc(q)}&rdquo;</h3><p>Revisa la ortograf\u00eda o explora las categor\u00edas de arriba.</p></div>`;
  let left='';
  if(queries.length){
    left+='<p class="bw-group-title">Sugerencias</p><ul class="bw-suggestions">';
    queries.slice(0,6).forEach(x=>{left+=`<li><a href="#" data-q="${esc(x.text)}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><span>${highlight(x.text,q)}</span></a></li>`;});
    left+='</ul>';
  }
  if(collections.length){
    left+='<p class="bw-group-title">Categor\u00edas</p><div class="bw-col-chips">';
    collections.slice(0,5).forEach(c=>{left+=`<a href="${c.url}" class="bw-col-chip">${highlight(c.text,q)}</a>`;});
    left+='</div>';
  }
  let right='';
  if(products.length){
    right+=`<div class="bw-prods-header"><h3>Productos (${products.length})</h3><a href="/search?q=${encodeURIComponent(q)}&type=product">Ver todos &rarr;</a></div><div class="bw-results-grid">`;
    products.forEach(p=>{right+=card(p.img,p.handle,p.vendor,p.title,p.price,p.cmp,p.badge);});
    right+='</div>';
  }
  return`<div class="bw-results">${hasL?`<div class="bw-results__left">${left}</div>`:''}<div class="bw-results__right">${right}</div></div>
  <div class="bw-footer"><a href="/search?q=${encodeURIComponent(q)}&type=product" class="bw-see-all">Ver todos los resultados para &ldquo;${esc(q)}&rdquo;</a></div>`;
}

let ac=null,dt=null;
const cache={};

function normalizeImg(raw){
  if(!raw)return null;
  let u=typeof raw==='string'?raw:(raw.url||raw.src||null);
  if(!u)return null;
  if(u.startsWith('//'))u='https:'+u;
  else if(!u.startsWith('http'))u='https://cdn.shopify.com'+u;
  if(!u.includes('width=')&&!u.includes('_400x'))u+=u.includes('?')?'&width=400':'?width=400';
  return u;
}

function doSearch(q,body,inp,ghostEl,ghostTyped){
  if(ac)ac.abort();
  ac=new AbortController();
  body.innerHTML='<div class="bw-loading"><div class="bw-spinner"></div></div>';
  const k=q.toLowerCase();
  if(cache[k]){applyResults(cache[k],q,body,inp,ghostEl,ghostTyped);return;}
  /* unavailable_products=last: muestra agotados al final, no los oculta */
  const url=`/search/suggest.json?q=${encodeURIComponent(q)}`
    +`&resources[type]=product,collection,query`
    +`&resources[limit]=10`
    +`&resources[options][unavailable_products]=last`;
  fetch(url,{signal:ac.signal,headers:{Accept:'application/json'}})
    .then(r=>r.ok?r.json():Promise.reject(r.status))
    .then(data=>{
      const res=data.resources?.results||{};
      const pl={
        queries:(res.queries||[]).map(x=>({text:x.text,url:x.url})),
        collections:(res.collections||[]).map(x=>({text:x.title,url:x.url})),
        products:(res.products||[]).map(x=>{
          /* suggest.json devuelve precio en UNIDADES (ej 239990.00) */
          const price=parseFloat(x.price||x.price_min||0);
          const cmp=parseFloat(x.compare_at_price||x.compare_at_price_min||0);
          return{title:x.title,handle:x.handle,vendor:x.vendor,available:x.available!==false,
            img:normalizeImg(x.featured_image||x.image),price,cmp,
            badge:cmp>price?'sale':(x.available===false?'sold':null)};
        })
      };
      cache[k]=pl;
      applyResults(pl,q,body,inp,ghostEl,ghostTyped);
    })
    .catch(e=>{if(e?.name==='AbortError')return;
      body.innerHTML=`<div class="bw-noresults"><h3>Sin resultados para &ldquo;${esc(q)}&rdquo;</h3><p>Intenta con otro t\u00e9rmino o explora las categor\u00edas.</p></div>`;});
}

function applyResults(pl,q,body,inp,ghostEl,ghostTyped){
  const suffix=getAC(q,pl.queries);
  if(ghostEl&&ghostTyped){ghostTyped.textContent=q;ghostEl.textContent=suffix;}
  body.innerHTML=resultsHTML(pl,q);
  body.querySelectorAll('[data-q]').forEach(el=>{
    el.addEventListener('click',e=>{
      e.preventDefault();
      const t=el.dataset.q;
      inp.value=t;
      if(ghostEl)ghostEl.textContent='';
      if(ghostTyped)ghostTyped.textContent='';
      inp.closest('#bw-overlay').querySelector('#bw-clear').removeAttribute('hidden');
      saveR(t);clearTimeout(dt);doSearch(t,body,inp,ghostEl,ghostTyped);
    });
  });
  body.querySelectorAll('.bw-card').forEach(a=>a.addEventListener('click',()=>saveR(q)));
}

function acceptAC(inp,ghostEl,ghostTyped,body){
  const full=inp.value+(ghostEl?.textContent||'');
  inp.value=full;
  if(ghostEl)ghostEl.textContent='';
  if(ghostTyped)ghostTyped.textContent='';
  clearTimeout(dt);
  doSearch(full,body,inp,ghostEl,ghostTyped);
}

function init(){
  let ov=document.getElementById('bw-overlay');
  if(!ov)return;
  document.body.appendChild(ov);
  ov=document.getElementById('bw-overlay');
  const closeBtn=ov.querySelector('#bw-close');
  const clearBtn=ov.querySelector('#bw-clear');
  const body=ov.querySelector('#bw-body');
  const inp=ov.querySelector('#bw-input');
  const ghostEl=ov.querySelector('#bw-ghost');
  const ghostTyped=ov.querySelector('#bw-ghost-typed');
  const form=ov.querySelector('#bw-form');
  if(!inp||!body)return;

  function bindBody(){
    body.addEventListener('click',function h(e){
      if(e.target.id==='bw-clr-r'){e.preventDefault();clearR();body.innerHTML=emptyHTML();bindBody();return;}
      const chip=e.target.closest('[data-q]');
      if(chip){e.preventDefault();const t=chip.dataset.q;inp.value=t;if(ghostEl)ghostEl.textContent='';if(ghostTyped)ghostTyped.textContent='';clearBtn.removeAttribute('hidden');saveR(t);clearTimeout(dt);doSearch(t,body,inp,ghostEl,ghostTyped);}
    });
  }

  function open(){
    ov.removeAttribute('hidden');
    document.documentElement.style.overflow='hidden';
    body.innerHTML=emptyHTML();
    body.scrollTop=0;
    if(ghostEl)ghostEl.textContent='';
    if(ghostTyped)ghostTyped.textContent='';
    bindBody();
    requestAnimationFrame(()=>requestAnimationFrame(()=>inp.focus()));
  }

  function close(){
    ov.setAttribute('hidden','');
    document.documentElement.style.overflow='';
    inp.value='';
    clearBtn.setAttribute('hidden','');
    if(ghostEl)ghostEl.textContent='';
    if(ghostTyped)ghostTyped.textContent='';
    if(ac)ac.abort();
    body.innerHTML='';
  }

  document.querySelectorAll('.bw-search-trigger').forEach(btn=>{
    btn.addEventListener('click',open);
    btn.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}});
  });
  closeBtn?.addEventListener('click',close);
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'&&!ov.hasAttribute('hidden')){close();return;}
    if(!ov.hasAttribute('hidden')&&ghostEl?.textContent&&(e.key==='Tab'||e.key==='ArrowRight'||e.key==='End')){
      e.preventDefault();acceptAC(inp,ghostEl,ghostTyped,body);
    }
  });
  clearBtn?.addEventListener('click',()=>{
    inp.value='';clearBtn.setAttribute('hidden','');
    if(ghostEl)ghostEl.textContent='';
    if(ghostTyped)ghostTyped.textContent='';
    if(ac)ac.abort();
    body.innerHTML=emptyHTML();bindBody();inp.focus();
  });
  inp.addEventListener('input',()=>{
    const q=inp.value;
    if(ghostEl)ghostEl.textContent='';
    if(ghostTyped)ghostTyped.textContent='';
    q?clearBtn.removeAttribute('hidden'):clearBtn.setAttribute('hidden','');
    clearTimeout(dt);
    if(!q.trim()){if(ac)ac.abort();body.innerHTML=emptyHTML();bindBody();return;}
    dt=setTimeout(()=>doSearch(q.trim(),body,inp,ghostEl,ghostTyped),180);
  });
  form?.addEventListener('submit',e=>{
    e.preventDefault();
    const q=inp.value.trim();
    if(!q)return;
    if(ghostEl)ghostEl.textContent='';
    if(ghostTyped)ghostTyped.textContent='';
    saveR(q);clearTimeout(dt);doSearch(q,body,inp,ghostEl,ghostTyped);
  });
}

document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();
